(function() {
    function Map() {
        this.mapDescriptionFadeInit = function() {
            var $mapPoint = $('.js-mapPoint');
            var $projectDescription = $('.map__objectDescription');
            var $projectDescription__content = $('.objectDescription__content', $projectDescription);

            $(document).mouseup(function(e) {
                if (!$mapPoint.is(e.target) && !$projectDescription.is(e.target) && $projectDescription.has(e.target).length === 0) {
                    $projectDescription.removeClass('animated fadeIn');
                    $projectDescription.addClass('animated fadeOut');
                    window.setTimeout(function() {
                        $projectDescription.removeClass('m--map__objectDescription_fadeIn animated fadeOut');
                    }, 400);
                }
            });

            $mapPoint.on('click', function(e) {
                e.stopPropagation();
                $projectDescription.removeClass('m--map__objectDescription_fadeIn animated fadeIn');
                var mapPointRegion = $(this).attr('data-region');
                var mapPointLeftPosition = $(this).css('left');
                var mapPointTopPosition = $(this).css('top');
                var $project = $('.project[data-region="' + mapPointRegion + '"]');

                $projectDescription__content.html($project.html());
                $projectDescription__content.children().css('display', 'block');
                $projectDescription.css('left', 'calc(' + mapPointLeftPosition + ' - ' + $projectDescription.css('width') + ' + 70px' + ')').css('top', 'calc(' + mapPointTopPosition + ' - ' + $projectDescription.css('height') + ' - 25px' + ')');
                $projectDescription.addClass('m--map__objectDescription_fadeIn animated fadeIn');

                var $projectDescriptionImMap = $('.map__objectDescription');
                var $projectObjectContext = $('.project');
                var $openProject = $('.openProject');
                var $openProjectFirstColumn = $('.openProject__firstColumn', $openProject);
                var $openProjectSecondColumn = $('.openProject__secondColumn', $openProject);
                var $openProjectRegion = $('.openProject__region', $openProjectFirstColumn);
                var $openProjectName = $('.openProject__projectName', $openProjectFirstColumn);
                var $openProjectInnerContent = $('.openProject__innerContent', $openProjectFirstColumn);
                var $openProjectTextContent = $('.openProject__textContent', $openProjectFirstColumn);
                var $openProjectCloseButton = $('.openProject__closeButton', $openProjectFirstColumn);
                var $openProjectPrevProjectButton = $('.openProject__prevProjectButton', $openProject);
                var $openProjectNextProjectButton = $('.openProject__nextProjectButton', $openProject);
                var $openProjectPhotoSliderContent = $(".openProject__photoSliderContent", $openProject);
                var $fullImageSwitcherButton = $('.js-fullImageSwitcher');
                var $fullImageSwitcherWrapper = $('.js-fullImageSwitcherWrapper');
                var $projectObject = $('.project__object', $projectObjectContext );
                var $projectObjectInMap = $('.project__object', $projectDescriptionImMap);

                $projectObjectInMap.on('click', function(e) {
                    e.stopPropagation();
                    $('html').addClass('m--html_overflowHidden');
                    $projectObjectParent = $(this).parent();
                    $openProjectInnerContent.removeClassWild('fade*');
                    $openProjectPhotoSliderContent.removeClassWild('fade*');

                    var $projectRegion = $('.project__region', $projectObjectParent);
                    var $projectPhotoContent = $('.objectPhotoContent', $(this));
                    $openProject.addClass('js-openProject_isShown');
                    $openProjectRegion.html($projectRegion.html());
                    $openProjectName.html($(this).html());
                    $openProjectNextProjectButton.attr('data-nextObjectId', $(this).attr('data-nextObjectId'));
                    $openProjectPrevProjectButton.attr('data-prevObjectId', $(this).attr('data-prevObjectId'));
                    $openProjectNextProjectButton.attr('data-nextObjectLinkId', $(this).attr('data-nextObjectLinkId'));
                    $openProjectPrevProjectButton.attr('data-prevObjectLinkId', $(this).attr('data-prevObjectLinkId'));
                    $openProjectFirstColumn.addClass('animated fadeInLeft');
                    $openProjectSecondColumn.addClass('animated fadeInRight');
                    $openProjectPhotoSliderContent.html($projectPhotoContent.html());
                    var sHandler = function(data) {
                        $openProjectTextContent.html(data.textContent);
                        $openProjectPhotoSliderContent.removeClassWild('fade*');   
                        $openProjectPhotoSliderContent.css('opacity', '0');
                        $openProjectPhotoSliderContent.html(data.galleryContent);    
                        $('.photoSlider__item').imagesLoaded( { background: true }, function() {
                            $('.js-photoSlider').slick({
                                arrows: true,
                                dots: true,
                                speed: 500,
                                dots: false,
                                prevArrow: '<div class="photoSlider__arrowBefore"></div>',
                                nextArrow: '<div  class="photoSlider__arrowNext"></div>'
                            });
                            $('.openProject__spinnerPreloader').removeClass('m--openProject__spinnerPreloader_isShown animated fadeIn');
                            $openProjectPhotoSliderContent.css('opacity', '1');
                        });
                    }

                    var eHandler = function(response) {
                        alert('Произошла ошибка. Попробуйте перезагрузить страницу');
                    }

                    var params = 'objectLinkId='+$(this).attr('data-projectLinkId');
                    
                    $.ajax({
                        type     : 'post',
                        url      : '/json/',
                        data     : { _do: 'get_object_content',
                                     objectLinkId: $(this).attr('data-projectLinkId')
                         },
                        dataType : 'json',
                        timeout  : 3000,
                        success  : sHandler,
                        error    : eHandler
                    });
                });
            });

            this.mapGradientAnimateInit = function() {
                var granimInstance = new Granim({
                    element: '#canvas-basic',
                    name: 'basic-gradient',
                    direction: 'left-right', // 'diagonal', 'top-bottom', 'radial'
                    opacity: [1, 1],
                    isPausedWhenNotInView: true,
                    states: {
                        "default-state": {
                            gradients: [
                                ['#262D29', '#1D2349'],
                                ['#214447', '#263965'],
                                ['#1D2349', '#214447'],
                                ['#20525a', '#283a38'],
                            ],
                            transitionSpeed: 4500
                        }
                    }
                });
            }
        }
    }
    proj.map = new Map();
})();